var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScaleway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 1024 1024",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    fill: "#4f0599",
    r: 512
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m610.2 493v122c-.7 18.4-14.6 33.7-32.9 36.1h-85.3c-14.3-1.1-25.9-11.9-27.9-26-.1-1.3-.1-2.6 0-3.8.1-16.1 13.2-29 29.2-29h37.1c11.8 0 21.3-9.6 21.3-21.3v-77.2c-.1-14.7 10.6-27.3 25.2-29.7h3.6c16.1-.2 29.4 12.7 29.7 28.8zm-137.8 37.1v-76.6c0-11.8 9.6-21.3 21.3-21.3h39.5c16.1 0 29.2-13.1 29.2-29.2.1-1.2.1-2.4 0-3.6-2.6-14.7-15.2-25.4-30.1-25.6h-84.5c-18.2 2.3-32.3 17.1-33.7 35.4v121.6c0 16.1 13.1 29.2 29.2 29.2h4.5c14.5-2.6 24.9-15.2 24.6-29.9zm256-91.5v244c-5.3 46-42.4 81.8-88.5 85.3h-161.7c-100.9-.1-182.6-81.9-182.6-182.8v-232.2c0-53.5 43.4-96.9 96.9-96.9h153.2c100.9 0 182.6 81.8 182.6 182.6zm-58.4 0c-.1-68.5-55.6-124-124.2-124.2h-153.4c-21.1-.1-38.3 16.9-38.4 38v.4 232.3c.4 68.4 55.8 123.6 124.2 123.7h158.7c16.7-2.1 30.1-15 32.9-31.6z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleway);
export default __webpack_public_path__ + "static/media/scaleway.2470ce530cca5f74f2b4ccd7806ea524.svg";
export { ForwardRef as ReactComponent };